import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Logo from './partials/Logo';
import FooterNav from './partials/FooterNav';
import FooterSocial from './partials/FooterSocial';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

const propTypes = {
    topOuterDivider: PropTypes.bool,
    topDivider: PropTypes.bool
}

const defaultProps = {
    topOuterDivider: false,
    topDivider: false
}

const Footer = ({
                    className,
                    topOuterDivider,
                    topDivider,
                    ...props
                }) => {

    const classes = classNames(
        'site-footer center-content-mobile',
        topOuterDivider && 'has-top-divider',
        className
    );

    return (
        <footer
            {...props}
            className={classes}
        >
            <div className="container">
                <div className={
                    classNames(
                        'site-footer-inner',
                        topDivider && 'has-top-divider'
                    )}>
                    <div className="footer-top space-between text-xxs">
                        <Logo width={256}/>
                        <FooterSocial/>
                    </div>
                    <div className="footer-bottom space-between text-xxs invert-order-desktop">
                        <FooterNav/>
                        <div className="footer-copyright">
                            <FormattedMessage
                                id="app.hero.footer_madeBy"
                                defaultMessage="Hecho por "
                            />
                            <Link to={'/'}>
                                ZecTelecom
                            </Link>
                            <FormattedMessage
                                id="app.hero.footer_copyright"
                                defaultMessage=". Todos los derechos reservados"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;